module.exports = __webpack_public_path__ + "img/portugal-congenital-and-perinatal-diseases-male.d0d0b6cc.png";